import React from 'react';
import { Percent } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getTaxBenefits, createTaxBenefit, updateTaxBenefit, deleteTaxBenefit, getEmployeeList } from '../hrisApi';

const STATUS_OPTIONS = ['Draft', 'Submitted', 'Approved', 'Rejected', 'Cancelled'];
const BENEFIT_TYPES = ['Tax Declaration', 'Tax Exemption', 'Flexible Benefit', 'Allowance', 'Insurance', 'Other'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'benefitType', label: 'Type' },
  { key: 'period', label: 'Period' },
  { key: 'amount', label: 'Amount', render: (v) => v ? `Rp ${Number(v).toLocaleString('id-ID')}` : '—' },
  { key: 'effectiveDate', label: 'Effective Date' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'benefitType', label: 'Benefit / Tax Type', type: 'select', required: true, options: BENEFIT_TYPES },
  { key: 'period', label: 'Period', type: 'text', placeholder: 'e.g. FY 2026' },
  { key: 'amount', label: 'Amount (Rp)', type: 'number', placeholder: '0' },
  { key: 'effectiveDate', label: 'Effective Date', type: 'date' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Draft' },
  { key: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Tax or benefit notes...' },
];

const TaxBenefits = () => (
  <HRISListPage
    title="Tax & Benefits"
    description="Manage employee tax declarations, exemptions, allowances, and benefits"
    icon={<Percent />}
    columns={columns}
    fetchData={getTaxBenefits}
    createData={createTaxBenefit}
    updateData={updateTaxBenefit}
    deleteData={deleteTaxBenefit}
    formFields={formFields}
    entityName="Tax / Benefit"
    searchPlaceholder="Search employee, benefit type, period..."
  />
);

export default TaxBenefits;
